import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import HostDashboard from "@/pages/HostDashboard";
import ListingForm from "@/pages/ListingForm";
import MotorcycleForm from "@/pages/MotorcycleForm";
import MyBookings from "@/pages/MyBookings";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id during render (NOT in useEffect) to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/listings" element={<Listings />} />
      <Route path="/listings/:id" element={<ListingDetail />} />
      <Route path="/dashboard" element={<HostDashboard />} />
      <Route path="/dashboard/new" element={<ListingForm />} />
      <Route path="/dashboard/edit/:id" element={<ListingForm />} />
      <Route path="/dashboard/motorcycles/new" element={<MotorcycleForm />} />
      <Route path="/dashboard/motorcycles/edit/:id" element={<MotorcycleForm />} />
      <Route path="/bookings" element={<MyBookings />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
